export const WORKFLOW_DEMO_STAGE_WIDTH = 1280;
export const WORKFLOW_DEMO_STAGE_HEIGHT = 800;
export const WORKFLOW_DEMO_DURATION_MS = 10_000;
export const WHATSAPP_WORKFLOW_DEMO_DURATION_MS = 26_000;
export const WHATSAPP_WORKFLOW_WHITE_HOLD_MS = 1_000;
export const EVOLUCAO_WORKFLOW_DEMO_DURATION_MS = 32_000;
export const EVOLUCAO_TRANSITION_DEMO_PROCESSING_MS = 4_000;
export const EVOLUCAO_TRANSITION_SCENE_MS = 13_000;
export const PRONTUARIO_WORKFLOW_PATIENTS_HOLD_MS = 2_000;
export const PRONTUARIO_WORKFLOW_DEMO_DURATION_MS = 11_450;

export type WorkflowAnimatedDemoId =
	| 'agendamentos'
	| 'chamada'
	| 'evolucao'
	| 'prontuario';

export const WORKFLOW_ANIMATED_DEMO_IDS: WorkflowAnimatedDemoId[] = [
	'agendamentos',
	'chamada',
	'evolucao',
	'prontuario',
];

export const isWorkflowAnimatedDemoId = (
	value: string,
): value is WorkflowAnimatedDemoId =>
	WORKFLOW_ANIMATED_DEMO_IDS.includes(value as WorkflowAnimatedDemoId);

export const isPhaseActive = (
	elapsedMs: number,
	startMs: number,
	endMs: number,
): boolean => elapsedMs >= startMs && elapsedMs < endMs;

export const phaseProgress = (
	elapsedMs: number,
	startMs: number,
	endMs: number,
): number => {
	if (elapsedMs < startMs) return 0;
	if (elapsedMs >= endMs) return 1;
	return (elapsedMs - startMs) / (endMs - startMs);
};
